import { render } from "./Express.vue?vue&type=template&id=ee315bee&scoped=true&ts=true"
import script from "./Express.vue?vue&type=script&lang=ts"
export * from "./Express.vue?vue&type=script&lang=ts"

import "./Express.vue?vue&type=style&index=0&id=ee315bee&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee315bee"]])

export default __exports__